import { ApiBase } from '@bymason/api-base';
import {
  ScopeModel,
  UpdateScopeModel,
  PermissionResponse,
  UpdateScopeResponse,
  PermissionSet,
} from './types';
export * from './types';

class Permission extends ApiBase {
  private static instance: Permission;

  private constructor() {
    super();
  }

  /**
   * There is no need for consumers to ever call this method as its purely used to enforce a singleton module pattern.
   * @returns An Permission instance
   */
  public static getInstance(): Permission {
    if (!Permission.instance) {
      Permission.instance = new Permission();
      Permission.instance.configure({
        fleet: 'permission',
      });
    }

    return Permission.instance;
  }

  /**
   * Gets a list of all available permissions.
   * @param options metadata required to get an permission.
   * @param clientToken token required for proper authorization.
   * @returns either an permission model or void
   */
  public async getScopes(clientToken: string) {
    const url = this.getEndpointTemplate('group/account/scope');

    const dataResponse = await this.callJsonEndpoint<ScopeModel[]>({
      clientToken,
      method: 'GET',
      url,
    });

    return dataResponse;
  }

  /**
   * Gets a list of all of the users in the account and their permissions
   * @param options metadata required to get an permission.
   * @param clientToken token required for proper authorization.
   * @returns either an permission model or void
   */
  public async getAccountPermissions(clientToken: string) {
    const url = this.getEndpointTemplate('group/account/name/global');

    const dataResponse = await this.callJsonEndpoint<PermissionResponse>({
      clientToken,
      method: 'GET',
      url,
    });

    return dataResponse;
  }

  /**
   * Updates the permissions for a user
   * @param options metadata required to get an permission.
   * @param clientToken token required for proper authorization.
   * @returns either an permission model or void
   */
  public async updateScopes(options: UpdateScopeModel[], clientToken: string) {
    const url = this.getEndpointTemplate('');

    const dataResponse = await this.callJsonEndpoint<UpdateScopeResponse>({
      body: JSON.stringify(options),
      clientToken,
      method: 'POST',
      url,
    });

    return dataResponse;
  }

  /**
   * Gets the permissions for the current user
   * @param clientToken token required for proper authorization.
   * @returns either an PermissionSet or void
   */
  public async getUserScopes(clientToken: string) {
    const url = this.getEndpointTemplate('');

    const dataResponse = await this.callJsonEndpoint<PermissionSet>({
      clientToken,
      method: 'GET',
      url,
    });

    return dataResponse;
  }
}

export const permissionClient = Permission.getInstance();
